// Components passed to every Resources MDX body. Custom ones are used as JSX
// in the MDX file without an import; `table` styles plain markdown tables.
import { Callout, KeyDates, Cite, Infographic, InlineCta, ProseTable } from './mdx.jsx';
import ComparisonTable from '@/components/ComparisonTable.jsx';
import CtaStrip from './CtaStrip.jsx';
import { PricingSummary } from '@/content/resources/PricingSummary.jsx';

export const MDX_COMPONENTS = { Callout, ComparisonTable, CtaStrip, KeyDates, Cite, Infographic, InlineCta, PricingSummary, table: ProseTable };
